export default __webpack_public_path__ + "static/media/COD.6f0fed32.svg";